<template>
    <BorrarModalComponent
        :name="'borrar-' + localDescuento.id"
        title="¿Seguro que quieres borrar este precio?"
        borrarTitle="Datos del precio"
        confirmButton="¿BORRAR PRECIO?"
        v-on:close="() => close(false)"
        v-on:confirm="() => borrarDescuento()"
    >
        <ul class="list-group list-group-unbordered mb-3">
            <li class="list-group-item">
                <b>Nombre:</b> {{ localDescuento.descripcion }}
            </li>
            <li class="list-group-item">
                <b>Precio:</b> {{ localDescuento.precio }}
            </li>
        </ul>
    </BorrarModalComponent>
</template>

<script>
    import BorrarModalComponent from "@/components/backend/components/BorrarModalComponent";

    export default {
        props: ['lista_id', 'precio_id', 'descuento'],
        data() {
            return {
                localDescuento: { ...this.descuento }
            }
        },
        methods: {
            close(borrado) {
                this.$emit('close', 'borrar-' + this.localDescuento.id, borrado);
            },
            borrarDescuento() {
                this.localDescuento.filters = {};
                this.localDescuento.lista_id = this.lista_id;
                this.localDescuento.precio_id = this.precio_id;
                this.localDescuento.descuento_id = this.descuento.id;

                this.$store.dispatch(this.config.getVuexAlias('back.precios.descuentos.borrar'), this.localDescuento).then(res => {
                    this.$toast.success(res.data.message);
                    this.close(true);
                }).catch(error => {
                    this.$toast.error(error);
                    console.log(error);
                });
            }
        },
        components: {
            BorrarModalComponent
        }
    }
</script>
